export const OCTOBER_DISTRICT = 6784
export const ZAELTSOVSKI_KALININSKI_DISTRICT = 6841
export const LENINSKI_CENTRAL_DISTRICT = 54

export default [
  OCTOBER_DISTRICT,
  ZAELTSOVSKI_KALININSKI_DISTRICT,
  LENINSKI_CENTRAL_DISTRICT,
]
